import Maple121 from "../Summarecon Bogor/Maple 12.webp"
import Maple122 from "../Summarecon Bogor/Maple 12.webp"

const Maple12images =[
    Maple121,Maple122
]

export default Maple12images;